import { useState, useCallback } from 'react'
import { ToastType } from '../../types'

interface ShowToastParams {
  type: ToastType['type']
  title: string
  message?: string
  duration?: number
}

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastType[]>([])

  const showToast = useCallback(({ type, title, message, duration = 5000 }: ShowToastParams) => {
    const id = Math.random().toString(36).substr(2, 9)
    const newToast: ToastType = {
      id,
      type,
      title,
      message,
      duration,
    }

    setToasts(prev => [...prev, newToast])

    // Auto-remove toast after duration
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }, [])

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id))
  }, [])

  const clearAllToasts = useCallback(() => {
    setToasts([])
  }, [])

  return {
    toasts,
    showToast,
    removeToast,
    clearAllToasts,
  }
}